import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8fbfd5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  role: "progressbar",
  class: "ProgressBar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ProgressBar-bar ProgressBar-bar--primary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ProgressBar-inner" })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ProgressBar-bar ProgressBar-bar--secondary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ProgressBar-inner" })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}